<h2 mat-dialog-title>REGISTRATION QR CODE</h2>

<div style="display: flex; justify-content: center; margin-top: 5px;">
    <!-- Use a canvas with a template reference variable to target each element -->
    <canvas #qrcodeCanvas class="qrcode"></canvas>
</div>

<div mat-dialog-actions class="action" align="end">
    <button mat-raised-button type="submit" color="primary" (click)="downloadQRCode()">DOWNLOAD</button>
</div>